module.exports = __webpack_public_path__ + "media/images/icons/cv-71ae7703d503315bd5fa026649d44262.gif";